import React, { useState } from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { Box, IconButton, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import { SOUS_CLIENT_SLICE_NAME, TiersObjectGroup } from '@europrocurement/l2d-domain';
import { useNavigate } from 'react-router-dom';
import { faEdit, faEye, faTrash } from '@fortawesome/sharp-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { useFullLayout } from '@europrocurement/flexy-components/components/templates/FullLayout/FullLayoutContext';
import { listeSocietesFullPath } from '../../../constants';
import { useSocieteGroupActionDispatch } from '../../../providers';

export type ActionMenuListeSocieteProps = {
    societeGroupe: TiersObjectGroup;
};

export const ActionMenuListSocieteGroup: React.FunctionComponent<ActionMenuListeSocieteProps> =
    function ({ societeGroupe }) {
        const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
        const open = Boolean(anchorEl);
        const navigate = useNavigate();
        const dispatch = useDispatch();
        const { palette } = useTheme();
        const modalDispatch = useSocieteGroupActionDispatch();
        const { setCustomizerDrawerOpen } = useFullLayout();

        const handleClick = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        const handleOpenSocieteGroupModal: (action: 'edit' | 'delete') => void = (action) => {
            if (modalDispatch) {
                modalDispatch({ type: action, payload: societeGroupe });
            }
            setAnchorEl(null);
        };

        // dispatch groupId to the societe store and navigate to the societe list
        const handleListSocieteLinkClick = () => {
            dispatch({
                type: `${SOUS_CLIENT_SLICE_NAME}/setmainFilter`,
                payload: {
                    key: 'objectgroups',
                    value: societeGroupe.id,
                },
            });
            setCustomizerDrawerOpen(false);
            navigate(`/${listeSocietesFullPath}`);
        };

        return (
            <div
                onClick={(e) => {
                    e.stopPropagation();
                }}
                onKeyDown={() => {}}
                role="button"
                tabIndex={0}
            >
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <FaOptionIcon
                        icon={['fasl', 'ellipsis-vertical']}
                        sx={{ fontSize: '1rem' }}
                    />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                        'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem>
                        <Box
                            sx={{ display: 'flex', gap: '4px' }}
                            onClick={handleListSocieteLinkClick}
                        >
                            <FaOptionIcon
                                icon={faEye}
                                sx={{ color: 'text.gris50' }}
                            />
                            <Typography variant="l2dbodys"> Voir les Societes</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem>
                        <Box
                            sx={{ display: 'flex', gap: '4px' }}
                            onClick={() => handleOpenSocieteGroupModal('edit')}
                        >
                            <FaOptionIcon
                                icon={faEdit}
                                sx={{ color: 'text.gris50' }}
                            />
                            <Typography variant="l2dbodys">Editer le groupe</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem>
                        <Box
                            sx={{ display: 'flex', gap: '4px' }}
                            onClick={() => handleOpenSocieteGroupModal('delete')}
                        >
                            <FaOptionIcon
                                icon={faTrash}
                                sx={{ fontSize: '1rem', color: palette.error.main }}
                            />
                            <Typography
                                variant="l2dbodys"
                                sx={{ color: palette.error.main }}
                            >
                                Supprimer
                            </Typography>
                        </Box>
                    </MenuItem>
                </Menu>
            </div>
        );
    };
